import React from 'react';
import Select from 'react-select';
import { PictureWithFallback } from '../sections/PictureWithFallback';
import { ChildDataFragment, ParentChildDropdownFragment } from '../../generated/spin-graphql';
import { gql } from '@urql/core';
import { useAppState } from 'client/providers/AppProvider';

type Props = {
    playerInfo: ParentChildDropdownFragment[] | ChildDataFragment[];
    value: any;
    onChange: (value) => void;
};

gql`
    fragment ParentChildDropdown on espin_parent_profile {
        child_profiles(where: { user: { deleted_at: { _is_null: true } } }) {
            user_id
            spin_username
            profile_image {
                ...SpinContentImageDisplay
            }
        }
    }
`;

export const ParentChildDropdown: React.FC<Props> = ({ playerInfo, value, onChange }) => {
    const { selectChild } = useAppState();
    const options = playerInfo[0].child_profiles.map((player, i) => ({
        label: player.spin_username,

        value: player,

        index: i,
    }));

    return (
        <div className={`select-field-container parent-child-select`}>
            <div className="image-wrapper">
                <PictureWithFallback
                    width={40}
                    height={40}
                    icon={value.profile_image}
                    alt={`${value.spin_username}'s profile picture`}
                />
            </div>

            {options.length > 1 ? (
                <Select
                    className={`select-container parent-child-select`}
                    classNamePrefix={`select`}
                    options={options}
                    isClearable={false}
                    isMulti={false}
                    value={!!value ? options.find((o) => o.value === value) : undefined}
                    onChange={(val) => {
                        onChange(val.index), selectChild(val.index);
                    }}
                />
            ) : (
                <Select
                    className={`select-container parent-child-select`}
                    classNamePrefix={`select`}
                    options={options}
                    isDisabled={true}
                    value={options[0]}
                />
            )}
        </div>
    );
};
